import { AnchoringRoundData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const dataTag = 'AnchoringRoundData';
export default class AnchoringRoundParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.ANCHORING_WATCH, FIXED_PROTOCOL_CONTENT_TYPE_IDS.ANCHORING_WATCH, dataTag, app);
    }
    getPropsMapping() {
        return {
            anchor: 'anchor',
            chainLength: 'chainLength',
            chainShake: 'chainShake',
            chainLeading: 'chainLeading',
            chainGrowing: 'chainGrowing',
            freeText: 'freeText',
        };
    }
    createData(props, record) {
        const data = new AnchoringRoundData(props.anchor, props.chainLength, props.chainShake, props.chainLeading, props.chainGrowing, props.freeText);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.anchor,
            };
            data.anchor = link;
        }
        return data;
    }
}
//# sourceMappingURL=AnchoringRoundParser.js.map